import React, { useRef } from 'react';
import { createStyles } from '@/contexts/theme-context';
import { Pressable } from 'react-native';
import { Typography } from '@usepepper/ui/atoms/typography';
import { useHover } from 'react-native-web-hooks';

interface Props {
  name: string;
  onPress: () => void;
}

export const PricingTableNameLink: React.FC<Props> = ({ name, onPress }) => {
  const [styles] = useStyles();
  const buttonRef = useRef<React.ComponentRef<typeof Pressable>>(null);
  const isHovered = useHover(buttonRef);

  return (
    <Pressable
      onPress={onPress}
      ref={buttonRef}
      style={styles.link}
      tabIndex={-1}
    >
      <Typography
        textDecorationLine={isHovered ? 'underline' : 'none'}
        variant="paragraph-md-600"
      >
        {name}
      </Typography>
    </Pressable>
  );
};

const useStyles = createStyles(() => ({
  link: {
    flexShrink: 1,
  },
}));
